// Will be replaced during production builds - see package.sh
export const BuildVersion = 'main-gha.10068';
